/* eslint-disable import/no-named-as-default */
import path from 'ramda/src/path';
import { getSelectedProductionCompaniesSelector } from 'redux-core/overview/selectors';
import { concatObjects } from 'utils/index';
import { getAdditionalData } from 'utils/forms';
import DRAWERS from '../../constants';

const rootT = 'drawers.productionSetup.release.items';

export const productionInformationItems = ({ keepReleaseInfo, setSelected, openDrawer, onSubmit }) => [
  {
    label: `${rootT}.distributors`,
    name: 'additionalData.distributors',
    action: (values, { readOnly }) => {
      keepReleaseInfo(values);
      openDrawer(DRAWERS.PRODUCTION_DETAILS_DISTRIBUTORS, {
        readOnly,
        rootT: 'drawers.productionSetup.defaultDistributors',
        edit: true,
        distributors: path(['additionalData', 'distributors'])(values),
        onSubmit,
      });
    },
  },
  {
    label: `${rootT}.networkBroadcaster`,
    name: 'additionalData.networks',
    action: (values, { readOnly }) => {
      keepReleaseInfo(values);
      openDrawer(DRAWERS.PRODUCTION_DETAILS_NETWORKS, {
        readOnly,
        rootT: 'drawers.productionSetup.defaultNetworks',
        edit: true,
        networks: path(['additionalData', 'networks'])(values),
        onSubmit,
      });
    },
  },
  {
    label: `${rootT}.productionCompanies`,
    name: 'additionalData.productionEntities',
    rootT: `${rootT}.productionEntities`,
    renderValues: concatObjects(', ', 'companyName'),
    action: (values, { readOnly }) => {
      keepReleaseInfo(values);
      setSelected(values);
      openDrawer(DRAWERS.PRODUCTION_SETUP_COMPANIES, {
        readOnly,
        onSubmit,
        getCompaniesSelector: getSelectedProductionCompaniesSelector,
      });
    },
  },
];

export const personnelInformationItems = ({
  keepPersonnelInfo,
  keepReleaseInfo,
  setSelected,
  openDrawer,
  onSubmit,
}) => [
  {
    label: `${rootT}.keyPersonnel`,
    name: 'additionalData.keyPersonnel',
    action: (values, { readOnly }) => {
      const keyPersonnelInfo = getAdditionalData('keyPersonnel')(values);
      keepPersonnelInfo(keyPersonnelInfo);
      keepReleaseInfo(values);
      setSelected(values);
      openDrawer(DRAWERS.PERSONNEL_LIST_PERSONNEL, {
        readOnly,
        edit: true,
        keyPersonnel: keyPersonnelInfo,
        onSubmit,
      });
    },
  },
  {
    label: `${rootT}.directors`,
    name: 'additionalData.directors',
    action: (values, { readOnly }) => {
      keepReleaseInfo(values);
      setSelected(values);
      openDrawer(DRAWERS.PRODUCTION_DETAILS_DIRECTORS, {
        readOnly,
        edit: true,
        directors: getAdditionalData('directors')(values),
        onSubmit,
      });
    },
  },
  {
    label: `${rootT}.producers`,
    name: 'additionalData.producers',
    action: (values, { readOnly }) => {
      keepReleaseInfo(values);
      setSelected(values);
      openDrawer(DRAWERS.PRODUCTION_DETAILS_PRODUCERS, {
        readOnly,
        edit: true,
        producers: getAdditionalData('producers')(values),
        onSubmit,
      });
    },
  },
  {
    label: `${rootT}.editors`,
    name: 'additionalData.editors',
    action: (values, { readOnly }) => {
      keepReleaseInfo(values);
      setSelected(values);
      openDrawer(DRAWERS.PRODUCTION_DETAILS_EDITORS, {
        readOnly,
        edit: true,
        rootT: `${rootT}.editors`,
        editors: getAdditionalData('editors')(values),
        onSubmit,
      });
    },
  },
  {
    label: `${rootT}.actors`,
    name: 'additionalData.actors',
    action: (values, { readOnly }) => {
      keepReleaseInfo(values);
      setSelected(values);
      openDrawer(DRAWERS.PRODUCTION_DETAILS_ACTORS, {
        readOnly,
        edit: true,
        actors: getAdditionalData('actors')(values),
        onSubmit,
      });
    },
  },
];
